import { atom } from 'jotai';
import { NullableFAQS } from '@models/faqs';

export const faqsAtom = atom<NullableFAQS>(null);
